import { render, staticRenderFns } from "./ImagePolicies.vue?vue&type=template&id=1a016c77&"
import script from "./ImagePolicies.vue?vue&type=script&lang=js&"
export * from "./ImagePolicies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports